
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import BacRadio from '@/components/BacRadio.vue'
import ChatAttachmentUploadComponent from './ChatAttachmentUploadComponent.vue'
import { Game } from '@/lib/models/Game'
import { ChatService } from '@/lib/chat/ChatService'

@Component({
  components: {
    BacRadio,
    ChatAttachmentUploadComponent
  }
})
export default class ChatInputMenu extends Vue {
  @Prop({ default: null }) chatService!: ChatService | null;

  games: Game[] = [];
  scrolledToBottom = false;

  checkScrolledToBottom () {
    const scrollContainer = document.getElementsByClassName('chat-challenge-scroll-container')[0] as HTMLElement
    if (!scrollContainer) {
      return 'senf'
    }
    this.scrolledToBottom = scrollContainer.scrollTop + scrollContainer.clientHeight === scrollContainer.scrollHeight
  }

  get pickedChallenge () {
    return this.$store.state.Chat.pickedChallenge
  }

  set pickedChallenge (pickedChallenge: number) {
    this.$store.commit('setPickedChallenge', pickedChallenge)
  }

  get picked () {
    return this.$store.state.Chat.uploadType
  }

  set picked (picked: '' | 'upload' | 'challenge') {
    this.$store.commit('setUploadType', picked)
  }

  @Watch('picked')
  onPickedChange () {
    this.$emit('pickedOption', this.picked)
  }

  @Watch('pickedChallenge')
  onPickedChallengeChange () {
    this.$emit(
      'pickedChallenge',
      this.games.find((game) => game.id === this.pickedChallenge)
    )
  }

  mounted () {
    this.loadGames()
  }

  @Watch('$store.state.PageURLRallyRound.rallyRound')
  async loadGames () {
    if (!this.$store.state.PageURLRallyRound.rallyRound.id) {
      return // rally round not loaded yet
    }
    this.games = await Game.getForRallyRound(
      this.$store.state.PageURLRallyRound.rallyRound.id
    )
  }

  openAttachmentDialog () {
    const chatAttachmentDialog = document.getElementById(
      'chat-attachment-file-dialog'
    )

    if (chatAttachmentDialog) {
      chatAttachmentDialog.click()
    }
  }

  onRadioButtonInput (event: any) {
    if (event.target.value === this.picked) {
      this.picked = ''
      return
    }
    this.picked = event.target.value
  }
}
